import useGlobalModal from 'shared/global-modal/libs/useGlobalModal'
import { clearAllSiteData } from 'shared/helpers/clearServiceWorkerScripts'
import { useHandleRequest } from 'shared/libs/hooks/useHandleRequest/useHandleRequest'
import { RouterPages } from 'shared/model/routes'

import { useNavigate } from 'react-router-dom'

import { useLazyLogoutQuery } from 'modules/Auth/services/authApi'
import { LogoutResponse } from 'modules/Auth/types/api'

import { usePersistor } from 'shared/config/redux/config/persistorContext'

export const useAuth = () => {
  const { handleError } = useHandleRequest()
  const navigate = useNavigate()
  const { closeModal } = useGlobalModal()

  const [logout, { isLoading: isLogoutLoading }] = useLazyLogoutQuery()

  const persistor = usePersistor()

  const handleLogout = async (): Promise<LogoutResponse | null> => {
    try {
      const res = await logout().unwrap()
      closeModal()
      if (res?.success) {
        persistor.pause()
        await persistor.flush()
        await persistor.purge()
        await clearAllSiteData()
        navigate(RouterPages.login)
      }
      return res
    } catch (err) {
      handleError(err)
      return null
    }
  }

  return { handleLogout, isLogoutLoading }
}
